import script from "./BlockAudioRepeat.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockAudioRepeat.vue?vue&type=script&setup=true&lang=js"

import "./BlockAudioRepeat.vue?vue&type=style&index=0&id=5e88b698&lang=css"

const __exports__ = script;

export default __exports__